import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import styled from "styled-components";

export const SoftLimitContentWrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-top: 10px;
`;

export const SoftLimitText = styled.p`
    ${setFontVariant("subtitle1")}
    text-align: center;
    padding-top: 16px;
    margin: 0;
    color: ${colorsPalettes.carbon["500"]};
`;
